// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "vendor-mapbox" + "." + "4a1d0789" + ".chunk.css";
};